<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <main
      class="scrollable container"
      :style="{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }"
    >
      <BillSvg :style="{marginBottom: '30px'}" />
      <h2 :style="{marginBottom: '20px'}">
        Your invoice has been <br />
        sent!
      </h2>
      <p
        :class="'t16'"
        :style="{marginBottom: '30px'}"
      >
        Qui ex aute ipsum duis. Incididunt adipisicing <br />
        voluptate laborum
      </p>
      <Button
        :title="'Done'"
        :style="{width: '50%'}"
        :onClick="() => $router.push(routes.TAB_NAVIGATOR)"
      />
    </main>
  </div>
</template>

<script setup>
// vendors
import {routes} from '@/routes';

// hooks
import {useOpacity} from '@/hooks';

// svg
import {BillSvg} from '@/assets/svg';

// components
import {Background} from '@/components';
import {Button} from '@/components';

// other
const opacity = useOpacity();
</script>
